import { render, staticRenderFns } from "./DictEx.vue?vue&type=template&id=ac8226b2&scoped=true"
import script from "./DictEx.vue?vue&type=script&lang=js"
export * from "./DictEx.vue?vue&type=script&lang=js"
import style0 from "./DictEx.vue?vue&type=style&index=0&id=ac8226b2&prod&scoped=true&lang=css"
import style1 from "./DictEx.vue?vue&type=style&index=1&id=ac8226b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8226b2",
  null
  
)

export default component.exports